export default {
  END_POINT: 'https://drmekclinic.pams.ai/api/dataadapter/apicall/2kHhMAQz1Wdi5UHP8VDz8OudBBw',
  AUTH: '9N#NmNQK4uEyoKAd7JYVMaFLQ3xOFMq8%8JcoYJyMKSzLmV9LX3RzLUmzd8aE5qE8'
}



// WEBPACK FOOTER //
// ./src/config/doctor-mek.js